import Vue from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'
import Vant from 'vant';
import 'vant/lib/index.css';
import Print from 'vue-print-nb';
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
import Message from 'muse-ui-message';
import { Lazyload } from 'vant';
import VueCookies from 'vue-cookies'
import { Table,TableColumn,Loading} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入echarts
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading)
Vue.use(VueCookies)

Vue.use(Lazyload, {
  lazyComponent: true
});
Vue.use(Message);
Vue.use(MuseUI);

Vue.use(Vant);
Vue.use(Print);


Vue.prototype.$http = axios
axios.defaults.baseURL = 'http://caiwuapi.itkeen.net/';
axios.interceptors.request.use((config)=>{
  config.headers.common['Authorization']='Bearer '+localStorage.token;
  return config;
})


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
